/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".eye[_ngcontent-%COMP%]{transform:translateX(-100%);background:0 0}.eye[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{background:0 0}"];
export { styles as styles };
